import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_article",
  "use": "micro_article-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_article\"><path fill-rule=\"evenodd\" d=\"M0 2C0 .895.887 0 2 0h6c1.105 0 2 .887 2 2v6c0 1.105-.887 2-2 2H2c-1.105 0-2-.887-2-2V2Zm2 1h6v1H2V3Zm0 3h4v1H2V6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol